var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.list.length >= _setup.visibleAdjusted && (_vm.max ? _vm.list.length < _vm.max : true))?_c('div',{staticClass:"load-more-button",on:{"click":_setup.showMore}},[_c('span',[_vm._v("Load more")]),_c('BaseIcon',{staticClass:"icon-arrow-down",attrs:{"name":"arrow-long-down"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }